import createVueApp from '@phoenix/createVueApp';
import StrapSizeContactModal from '@maison/components/StrapSizeContactModal.vue';

const app = createVueApp();
app.component('StrapSizeContactModal', StrapSizeContactModal);
app.mount('#phoenix-strap-size-contact-modal');
